import React, {useState, useEffect} from "react";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Main,
  Timeline,
  Expertise,
  Project,
  Education,
  Contact,
  Navigation,
  Footer,
  RobotMascot,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';

function App() {
    const [mode, setMode] = useState<string>('dark');
    const [scrollProgress, setScrollProgress] = useState<number>(0);
    const [showBackToTop, setShowBackToTop] = useState<boolean>(false);

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);

        const handleScroll = () => {
            const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (totalHeight > 0) {
                const currentProgress = (window.scrollY / totalHeight) * 100;
                setScrollProgress(currentProgress);
            }
            setShowBackToTop(window.scrollY > 400);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
        {/* Reading Scroll Progress Bar */}
        <div
            className="scroll-progress-bar"
            style={{ width: `${scrollProgress}%` }}
        />

        <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
        <RobotMascot />
        <FadeIn transitionDuration={700}>
            <Main/>
            <Expertise/>
            <Timeline/>
            <Project/>
            <Education/>
            <Contact/>
        </FadeIn>

        {/* Floating Back to Top Button */}
        {showBackToTop && (
            <button
                className="back-to-top-btn"
                onClick={scrollToTop}
                aria-label="Back to top"
            >
                <KeyboardArrowUpIcon />
            </button>
        )}

        <Footer />
    </div>
    );
}

export default App;